import React, { useEffect, useState } from "react";
import VideoDisplay from "../components/VideoDisplay";
import Thumbnails from "../components/Thumbnails";
import { useParams } from "react-router-dom";
import axios from "axios";
import API_URL from "../config";

const VideoInterFace = () => {
  const { id } = useParams(); // video id from URL
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Fetch videos from backend
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/videos`);
        setVideos(res.data.videos);
      } catch (err) {
        console.error("Failed to fetch videos:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  if (loading) return <p className="text-center mt-20">Loading videos...</p>;
  if (!videos.length) return <p className="text-center mt-20">No videos available</p>;

  // Find current video
  const currentVideo = videos.find(v => v._id === id) || videos[0]; // fallback to first video

  return (
    <div className="flex flex-col md:flex-row justify-center mt-6 px-4 md:px-10">
      {/* Main Video */}
      <div className="flex-1 flex justify-center">
        <VideoDisplay
          key={currentVideo._id} // force re-render when switching videos
          src={currentVideo.url}
          title={currentVideo.title}
          publisher={currentVideo.publisher}
        />
      </div>

      {/* Thumbnails */}
      <div className="w-full md:w-[300px] lg:w-[350px] md:ml-8 mt-6 md:mt-0 flex flex-col gap-4 items-center md:items-stretch">
        {videos
          .filter(v => v._id !== currentVideo._id)
          .map(v => (
            <Thumbnails
              key={v._id}
              id={v._id}
              src={v.thumbnailUrl || "/placeholder.jpg"} // optional placeholder if no thumbnail
              title={v.title}
              publisher={v.publisher}
            />
          ))}
      </div>
    </div>
  );
};

export default VideoInterFace;
